import { getTenantMetaText } from './tenantMetaTexts'

import type { RouteMetaRule } from "./types"

export const routeMetaRules: RouteMetaRule[] = [
    // login
    {
        path: "/login/2fa",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/login",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },

    // forgot-password
    {
        path: "/forgot-password/confirm",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/forgot-password/success",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/forgot-password",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },

    // sign-up
    {
        path: "/sign-up/:accountType/confirm-email",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up/:accountType/confirm-phone",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up/:accountType/registration-phone",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up/:accountType/check-kyb",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up/:accountType/verification-pending",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up/:accountType",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
    {
        path: "/sign-up",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'signUp')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },

    // root (если есть редирект/нормализация)
    {
        path: "/",
        end: true,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },

    // fallback 404 (не обязательно, но удобно)
    {
        path: "*",
        end: false,
        resolve: ({ tenant }) => {
            const t = getTenantMetaText(tenant.tenantId, 'login')
            return {
                title: t.title,
                description: t.description,
            }
        },
    },
]
